import { Box } from '#/components/Box/Box';
import { LoadingSection } from '#/components/LoadingSection/LoadingSection';
import type { CmsApiRecommendedJobsBlockData } from '#/modules/cms/api/types/blocks/CmsApiRecommendedJobsBlock';
import { colors, gutterWidth } from '#/theme/theme';
import { dynamic } from '#/utils/dynamic';

const DynamicCmsStandardRecommendedJobs = dynamic(
  () =>
    import('#/modules/cms/blocks/RecommendedJobs/Standard/CmsStandardRecommendedJobs').then(
      (m) => ({ default: m.CmsStandardRecommendedJobs }),
    ),
  { strategy: 'client-only', placeholder: <LoadingSection /> },
);

type Props = {
  data: CmsApiRecommendedJobsBlockData;
  fromCheckbox?: boolean;
};

export function CmsRecommendedJobsBlock({ data, fromCheckbox }: Props) {
  const source = fromCheckbox
    ? 'RECOMMENDED_JOBS_CHECKBOX'
    : 'RECOMMENDED_JOBS_BLOCK';

  if (data.layout === 'SLIM') {
    // Additional gutter to position the arrows within the box
    const additionalXGutter = 76;

    return (
      <Box
        mx={[-gutterWidth / 2, null, -gutterWidth]}
        py={[gutterWidth / 2, null, gutterWidth]}
        px={[
          gutterWidth / 2,
          gutterWidth,
          gutterWidth + additionalXGutter,
          gutterWidth + additionalXGutter,
        ]}
        bg={colors.inputGrey}
        qaId="recommended-jobs"
        data-qa-layout={data.layout}
        data-qa-source={source}
        data-qa-job-function={data.jobFunction}
        data-qa-area-of-focus={data.areaOfFocus}
      >
        <DynamicCmsStandardRecommendedJobs
          headline={data.headline}
          layout={data.layout}
          jobFunction={data.jobFunction}
          areaOfFocus={data.areaOfFocus}
          recommendedLocale={data.locale}
          source={source}
        />
      </Box>
    );
  }

  return (
    <div
      data-qa-id="recommended-jobs"
      data-qa-layout={data.layout}
      data-qa-source={source}
      data-qa-job-function={data.jobFunction}
      data-qa-area-of-focus={data.areaOfFocus}
    >
      <DynamicCmsStandardRecommendedJobs
        headline={data.headline}
        layout={data.layout}
        jobFunction={data.jobFunction}
        areaOfFocus={data.areaOfFocus}
        recommendedLocale={data.locale}
        source={source}
      />
    </div>
  );
}
